

<template>

	<div class="index-component component-view h-100" :class="[currentFilterClasses]">

		<transition name="fade">
			<a :href="selection.bereich.link + `&L=` + languageUid" class="product-link" v-if="!showBereichsNav && selection.bereich && selection.bereich.link && !showOption">
				<div class="d-none d-md-flex align-items-center">
					<i class="fas fa-angle-right mr-2"></i> {{ LL('more_infos') }}
				</div>
			</a>
		</transition>

		<transition name="fade">
			<a class="menu-bereiche" v-if="!showBereichsNav && selection.bereich && !showOption" @click="onClickMenu">
				<div class="d-flex align-items-center">
					<i class="menu-icon fas fa-bars mr-5"></i>
					<span class="d-none d-md-flex align-items-center btn-bereich px-5 py-2" 
						:class="[selection.bereich.colorClass]">
							<i class="mr-2 apf" :class="[selection.bereich.iconClass]"></i>
							{{ selection.bereich.title }}
					</span>
				</div>
			</a>
		</transition>

		<transition name="fade">
			<div v-if="showBereichsNav" class="intro text-center h-100 d-flex flex-column justify-content-center">
				<h2>{{ LL('title_modular') }}</h2>
				<p>{{ LL('intro') }}</p>
				<NavBereiche @bereich-selected="setGlobalFilterCriteria"></NavBereiche>
			</div>
		</transition>

		<div class="options-overlay" :class="{in:showOption}">
			<transition name="fade">
				<NavOptionen v-for="item, key in selects" 
					v-if="showOption == key" 
					:title="item.title" 
					:color="colors[key]" 
					:optName="key" 
					:filters="filters"
					:key="key"
					@close="onClickCloseOption"
					@option-selected="addFilter" 
					@color-selected="selectColor" 
					@option-unselected="removeFilter" 
				/>
			</transition>
		</div>

		<div class="bubbles">
			<NavBubble v-for="item, key in selects"
				:title="item.title"
				:key="key"
				:selection="selection"
				:filters="filters"
				:optName="key"
				:className="`bubble-`+key+` `+item.bubbleClass"
				ref="bubble"
				@clicked="onClickBubble"
			/>
		</div>

		<Illustration :selection="selection" :optionsVisible="showOption"></Illustration>
		<IntroAnimation :visible="showBereichsNav"></IntroAnimation>

	</div>
</template>

<script>

import { mapState } from 'vuex';
import { EventBus } from '@/common/eventbus.js';
import { Log } from '@/services/log.service';
import { Finder } from '@/services/finder.service';
import { KombiRepository } from '@/repositories/KombiRepository';
import { KomponentenRepository } from '@/repositories/KomponentenRepository';

import { gsap, TweenMax, TimelineMax, Power2, Power3, Power4 } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin);

export default {
	props: [],
	data: function () {
		return {
			showBereichsNav: true,
			hideBubbles: true,
			showOption: false,
			selection: {},
			filters: {},
			fromType: false,
			toType: false,
			colors: {
				huelse: 'transparent',
				kappe: 'transparent',
			}
		}
	},
	computed: {
		...mapState('settings', ['presets']),
		...mapState('globals', ['language', 'languageUid']),
		...mapState('configurator', ['komponenten', 'kombis', 'selects', 'preselect']),
		allFilters() {
			return Object.assign({}, KombiRepository.getGlobalCriteria(), this.filters);
		},
		optionTitle() {
			for (var key in this.selects) {
				if (key == this.showOption) return this.selects[key].title;
			}
			return '';
		},
		currentFilterClasses() {
			var tmp = [];
			for (var i in this.allFilters) {
				tmp.push(`${i}-${this.allFilters[i]}`);
			}
			return tmp.join(' ');
		}
	},
	watch: {
		showOption( val ) {
			var hidden = val && this.allFilters.bereich != undefined;
			var elements = [];
			this.hideBubbles = hidden;
		},
		hideBubbles( hidden ) {
			this.$refs.bubble.forEach((item) => {
				item.out = hidden;
			});
		}
	},

	mounted() {
		if (this.preselect && Object.keys(this.preselect).length) {
			this.setGlobalFilterCriteria({filter:this.preselect});
		}
	},

	beforeDestroy() {
	},

	methods: {

		/**
		 * 	Click auf einen Bubble:
		 * 	Optionen zeigen.
		 * 
		 */
		onClickBubble( event ) {
			this.showOption = event.optName;
		},

		onClickCloseOption() {
			this.showOption = false;
		},

		onClickMenu() {
			this.showBereichsNav = true;
			this.hideBubbles = true;
			this.showOption = false;
			this.selection = {};
		},

		/**
		 * 	Setzt globalen Filter für ALLE Queries an das
		 * 	KombiRepository. In diesem Fall der {bereich:'...'}.
		 * 
		 */
		setGlobalFilterCriteria ( data ) {
			Log.INFO( 'Index.vue', 'setGlobalFilterCriteria', data );

			// Globalen Filter im <KombiRepository> setzen
			KombiRepository.setGlobalCriteria( data.filter );

			// Aktuellen Filter auf Defaults zurücksetzen
			if (data.filter.bereich) {
				var defaults = KomponentenRepository.find('bereich', data.filter.bereich).defaults || {};
				this.filters = Object.assign({}, defaults);
				this.rebuildPreview();
			} else {
				// Einfachen Redraw der Komponenten in diesem Vue erzwingen
				this.filters = {};
				this.addFilter();
			}

			this.hideBubbles = true;
			this.showBereichsNav = false;

			setTimeout(() => {
				this.hideBubbles = !!this.showOption;
			}, 1000);
		},


		/**
		 * 	Preview komplett ab- und wieder aufbauen.
		 * 	Schönerer für Übergang zwischen zwei Bereichen
		 * 
		 */
		rebuildPreview() {
			this.selection = {};
			this.$nextTick(() => {
				this.updatePreview();
			});
		},

		/**
		 * 	Einen zusätzlichen Filter (AUSSER globalen Filter {bereich:'...'}) setzen,
		 * 	z.B. {flasche:'gewinde'}.
		 * 
		 */
		addFilter( data ) {
			
			if (!data) data = {filter:{}};
			//Log.INFO( 'Index.vue', 'addFilter', data.filter );

			var newFilter = Object.assign({}, this.filters);
			for (var i in data.filter) {
				newFilter[i] = data.filter[i];
			}
			this.filters = newFilter;
			this.updatePreview();
			//Log.INFO('Index.vue', 'addFilter', newFilter);
		},

		/**
		 * 	Einen Filter entfernen
		 * 
		 */
		removeFilter( data ) {
			var newFilter = Object.assign({}, this.filters);
			delete( newFilter[data.optName] );
			this.filters = newFilter;
			this.updatePreview();
			//Log.INFO('Index.vue', 'removeFilter: ' + data.optName);
		},
		
		/**
		 * 	Eine Farbe auswählen
		 * 
		 */
		selectColor( data ) {
			this.colors[data.optName] = data.typ;
			this.updatePreview();
			//Log.INFO('Index.vue', 'selectColor: ' + data.typ);
		},

		/**
		 * 	Update der Preview
		 * 
		 */
		updatePreview() {

			var filters = Object.assign({}, this.filters);

			var resultsForFilters = {};
			var results = KombiRepository.findByCriteria( filters );
			
			if (!results.length) return;
			var firstResult = results.shift();

			// Flasche und Verschluss sind identisch.
			if (filters.verschluss) {
				filters.flasche = filters.verschluss;
			}

			for (var i in filters) {
				resultsForFilters[i] = firstResult[i];
			}

			// .farbe einfügen mit Referenz zur ausgewählten Farbvariante
			for (var i in this.colors) {
				if (resultsForFilters[i]) {
					resultsForFilters[i].farben.forEach((color) => {
						if (color.typ == this.colors[i]) {
							resultsForFilters[i].farbe = color;
						}
					});
				}
			}
			Log.INFO( 'Index.vue', 'updatePreview()', firstResult);
			//Log.INFO( 'Index.vue', 'updatePreview()', resultsForFilters );

			var globalCriteria = Object.assign({}, KombiRepository.getGlobalCriteria());
			for (var i in globalCriteria) {
				globalCriteria[i] = firstResult[i];
			}

			this.selection = Object.assign({viewport:firstResult.viewport}, globalCriteria, resultsForFilters);
		},


	}
}
</script>

<style lang="scss">

	.bubbles {
		animation-duration: 0.4s;
		position: absolute;
		left: 0;
		right: 0;
		top: 20px;
		bottom: 30px;
		z-index: 5;
		@media (min-width: 768px) {
			height: 100%;
			top: 0;
			bottom: 0;
		}
	}
	.bubble-verschluss {
		top: 75%;
		left: 40%;
	}
	.bubble-kopf {
		top: 60%;
		left: 59%;
	}
	.bubble-huelse {
		top: 40%;
		left: 41%;
	}
	.bubble-kappe {
		top: 20%;
		left: 50%;
	}
	.bubble-product {
		top: 20%;
		left: 42%;
	}

	.huelse-sideActuation .bubble-huelse {
		top: 34%;
		left: 38%;
	}

	.bereich-otologisch,
	.bereich-bukkal {
		.bubble-kappe {
			top: 33%;
			left: 50%;
		}
		.bubble-kopf {
			top: 60%;
		    left: 59%;
		}
		&.kappe-bukkal .bubble-kappe {
			top: 27%;
		}
		&.kappe-bukkal .bubble-kopf {
			top: 69%;
		}
	}

	.bereich-topisch {
		.bubble-kappe {
			top: 20%;
		}
		&.verschluss-crimp {
			.bubble-kappe {
				top: 36%;
			}
		}
		&.verschluss-snapOn {
			.bubble-kappe {
				top: 36%;
			}
		}
		&.verschluss-gewinde {
			.bubble-kappe {
				top: 26%;
			}
		}
		&.verschluss-snapOnOne {
			.bubble-kappe {
				top: 43%;
			}
			.bubble-verschluss {
				left: 34%;
			}
			.bubble-kopf {
				left: 58%;
				top: 52%;
			}
		}
	}

</style>

<style scoped lang="scss">

	.menu-bereiche {
		position: absolute;
		top: 15px;
		left: 0;
		z-index: 20;
		@media (min-width: 768px) {
			top: 30px;
			left: 30px;
		}
		cursor: pointer;
		transition: 0.2s all;
		span {
			box-shadow: 0 0 3px 2px rgba(#000, 0.2);
			user-select: none;
		}
		.apf {
			font-size: 1.5rem;
		}
		.menu-icon {
			font-size: 1.5rem;
		}
	}
	.product-link {
		position: absolute;
		right: 40px;
		bottom: 20px;
		z-index: 20;
		font-size: 1.2rem;
		font-weight: 400;
		color: #fff;
	}
	.intro {
		position: relative;
		z-index: 20;
		animation-duration: 0.3s;
		&.fade-enter-active {
			animation-delay: 1.5s;
		}

		@media (min-width: 800px) {
			h2 {
				font-size: 1.9rem;
			}
			p {
				font-size: 1.1rem;
			}
		}
	}

	.options-overlay {

		background: #fff;
		opacity: 0;
		pointer-events: none;
		transition: 0.5s all cubic-bezier(0.55, 0.055, 0.675, 0.19) 0s;
		transform: translateX(100px);
		visibility: hidden;
		position: absolute;
		z-index: 25;
		margin: 0 -15px;
		@media (min-width: 900px) {
			right: 50px;
			top: 50px;
			bottom: 50px;
			max-width: 500px;
			margin: 0;
		}
		&.in {
			opacity: 1;
			transition: 1s all cubic-bezier(0.23, 1, 0.32, 1) 1.2s;
			transform: translateX(0);
			pointer-events: auto;
			visibility: visible;
		}
	}

	.index-component {
		//background: rgba(#084c91, 0.9);
	}

	nav {
		padding: 0 0 0 5rem;
	}
	h1 {
		color: #fff;
	}

</style>



// WEBPACK FOOTER //
// src/views/Index.vue